export default [
  // Router kết nối ứng dụng misa
  {
    path: '/connect',
    name: 'connectMisaApp',
    component: () => import('@/views/connect/ConnectMisaApp.vue'),
    meta: {},
  },
];
